import { defineTokens } from "../../core"

export const lineHeights = defineTokens.lineHeights({
  shorter: 1.25,
  short: 1.375,
  moderate: 1.5,
  tall: 1.625,
  taller: 2,
})
